export class AppointmentAnalyticService {
  private static trackEvent = (props: analytics.TrackEvent): void => {
    props.ref?.current?.dispatchEvent(props.event);
  };

  static trackAppointmentEvent = (props: analytics.TrackModalLoad): void => {
    const event = new CustomEvent('modalLoadEvent', {
      detail: {
        modalEvent: `:${props.value}`,
      },
    });
    AppointmentAnalyticService.trackEvent({
      ref: props.ref,
      event,
    });
  };

  static trackAmendApptApiError = (props: analytics.AmendApptApiError): void => {
    const event = new CustomEvent('amendApptApiError', {
      detail: {
        modalEvent: `${props.modal}:${props.value}`,
      },
    });
    AppointmentAnalyticService.trackEvent({
      ref: props.ref,
      event,
    });
  };

  static trackAmendApptApiSuccess = (ref: React.RefObject<HTMLDivElement | null>): void => {
    const event = new CustomEvent('amendApptApiSuccess', {});
    AppointmentAnalyticService.trackEvent({
      ref,
      event,
    });
  };
}
